const zh = {
  common: {
    back: '返回',
    cancel: '取消',
    confirm: '确认',
    save: '保存',
    saving: '保存中...',
    delete: '删除',
    edit: '编辑',
    view: '查看',
    loading: '加载中...',
    noData: '暂无数据',
    error: '操作失败',
    success: '操作成功',
    retry: '重试',
    more: '更多',
    all: '全部',
    search: '搜索',
    close: '关闭',
    publish: '发布',
    publishing: '发布中...',
    anonymous: '匿名',
    author: '作者',
    reply: '回复',
    share: '分享',
    follow: '关注',
    followed: '已关注',
    followSuccess: '关注成功',
    unfollowSuccess: '已取消关注',
    bookmarked: '已收藏',
    unbookmarked: '已取消收藏',
    linkCopied: '链接已复制',
    loginRequired: '请先登录',
    imageTooLarge: '图片不能超过5MB',
    imageUploadFailed: '图片上传失败',
    commentSent: '评论发送成功',
    replySent: '回复成功',
    commentFailed: '评论失败，请重试',
    publishSuccess: '发布成功 ✨',
    publishFailed: '发布失败',
    unknownError: '未知错误',
    uploadFailed: '上传失败',
    avatarUpdated: '头像已更新',
    preferencesUpdated: '偏好已更新',
    saveFailed: '保存失败',
  },
  nav: {
    home: '首页',
    discover: '发现',
    create: '创建',
    messages: '消息',
    profile: '我的',
  },
  discover: {
    pageTitle: 'AI 智能服务',
    self: '本人',
    add: '添加',
    setupProfile: '创建个人档案',
    setupProfileHint: '填写出生信息，解锁专属个性化分析',
    bannerTitle: '"探索属于你的人生蓝图。"',
    bannerSubtitle: 'Discover your cosmic blueprint',
    bannerDesc: '选择你的档案，开启专属的 AI 智能服务。基于你的个人信息，获取精准的分析与指引。',
    profilesTitle: '个人档案',
    servicesTitle: 'AI 智能服务',
    needProfileTitle: '需要个人档案',
    needProfileDescNoProfile: '使用 AI 服务前，请先创建您的个人档案，以便提供精准的个性化分析。',
    needProfileDescSelectProfile: '请先在上方选择一个档案后再使用 AI 服务。',
    cancel: '取消',
    goCreate: '去创建',
    ok: '好的',
    services: {
      tarot: { title: '灵感卡牌', subtitle: 'CueCards' },
      astrology: { title: '星象罗盘', subtitle: 'StarScope' },
      ziwei: { title: '紫微解析', subtitle: 'ZiweiLens' },
      bazi: { title: '生辰解析', subtitle: 'BirthCode' },
      query: { title: '量子问答', subtitle: 'QuantumAsk' },
      travel: { title: '行程顾问', subtitle: 'CueGo' },
      fengshui: { title: 'AI 空间', subtitle: 'Space Harmony' },
      dream: { title: '梦境解析', subtitle: 'Dream Journal' },
    },
    mall: '好物商城',
    mallComingSoon: '🛍️ 好物商城即将上线，敬请期待',
    mallComingSoonDesc: '精选好物，提升生活品质',
    prediction: '趣味预测',
    predictionComingSoon: '🎯 趣味预测即将上线，敬请期待',
    predictionComingSoonDesc: '趣味预测，赢取积分奖励',
    serviceComingSoon: '✨ 该功能暂未开放，敬请期待',
    serviceComingSoonDesc: '我们正在加紧开发中…',
  },
  home: {
    refreshing: '刷新中...',
    pullToRefresh: '松手刷新',
    dailyEnergy: '今日能量',
    goSetup: '去设置',
    more: '更多',
    setupDesc: '设置你的个人档案，解锁专属每日分析',
    setupCta: '设置档案，解锁个性化服务',
    score: '分',
    calculating: '正在计算今日运势…',
    defaultTip: '感受当下的能量',
    dimLove: '爱情',
    dimWealth: '财富',
    dimCareer: '事业',
    dimStudy: '学习',
    dimSocial: '人际',
    recommend: '推荐',
    filterTitle: '筛选推荐偏好',
    filterDesc: '选择 3 个你感兴趣的方向',
    filterSaving: '保存中...',
    filterConfirm: '确认偏好',
    prefUpdated: '偏好已更新',
    prefSaveFailed: '保存失败',
  },
  profile: {
    title: '个人中心',
    noNickname: '未设置昵称',
    editProfile: '编辑资料',
    viewHomepage: '查看主页',
    posts: '发布',
    followers: '粉丝',
    following: '关注',
    likes: '获赞',
    points: '积分',
    pointsTip: '发帖 / 邀请好友可获取积分',
    invitation: '邀请好友',
    inviteBannerTitle: '邀请好友赚积分',
    inviteBannerDesc: '邀1人得10积分',
    openVip: '开通 VIP',
    vipDesc: '解锁全部高级功能',
    vipNotOpen: '暂未开放，敬请期待',
    myContent: '我的内容',
    postHistory: '发布记录',
    likesAndBookmarks: '赞与收藏',
    browseHistory: '浏览记录',
    mysticalServices: 'AI 服务',
    astroProfile: '个人档案',
    dailyFortune: '每日分析',
    settings: '设置',
    languageSwitch: '语言切换',
    notifications: '通知设置',
    notifOn: '已开启',
    notifOff: '未开启',
    notifAlreadyOn: '通知已开启',
    notifGoSettings: '请在系统设置中开启通知权限',
    notifEnabled: '通知已开启',
    logout: '退出登录',
    logoutConfirmTitle: '确认退出',
    logoutConfirmDesc: '退出后需要重新登录才能使用。确定要退出吗？',
    deleteAccount: '注销账号',
    deleteAccountConfirmTitle: '确认注销账号',
    deleteAccountConfirmDesc: '注销后，您的所有数据将被永久删除且无法恢复。确定要继续吗？',
    deleteAccountSuccess: '账号已注销',
    deleteAccountError: '注销失败，请稍后重试',
    deleting: '注销中...',
    levelBronze: '青铜',
    levelSilver: '白银',
    levelGold: '黄金',
    levelDiamond: '钻石',
    switchedTo: '已切换到 {{name}}',
    sessionExpired: '登录已过期，请重新登录',
    phoneLogin: '手机号登录',
    emailLogin: '邮箱登录',
    accountInfo: '账号信息',
    switchAccount: '切换账号',
    accountsCount: '个账号',
    loginMethod: '登录方式',
    accountDetails: '账号详情',
    email: '邮箱',
    phone: '手机号',
    registeredAt: '注册时间',
    lastLogin: '上次登录',
    feedback: '问题反馈',
    currentAccount: '当前账号',
    otherAccounts: '其他账号',
    online: '在线',
    switchTo: '切换',
    switching: '切换中',
    addAccount: '添加账号',
  },
  languageDrawer: {
    title: '语言切换',
    zhLabel: '简体中文',
    enLabel: 'English',
    confirmSwitch: '确认更换',
  },
  editProfile: {
    title: '编辑资料',
    nickname: '昵称',
    nicknamePlaceholder: '输入你的昵称',
    bio: '个人简介',
    bioPlaceholder: '介绍一下自己...',
    userId: '用户 ID',
    uploading: '上传中...',
    clickToChangeAvatar: '点击更换头像',
    defaultAvatars: '默认头像',
    chooseAvatar: '选择默认头像',
    customUpload: '自定义',
    saveChanges: '保存修改',
    nicknameEmpty: '昵称不能为空',
    nicknameTooLong: '昵称不能超过30个字符',
    nicknameTaken: '该昵称已被使用，请换一个',
    bioTooLong: '简介不能超过200个字符',
    imageTooLarge: '图片大小不能超过 5MB',
    selectImage: '请选择图片文件',
    uploadFailed: '上传失败',
    avatarUpdated: '头像已更新',
    saveFailed: '保存失败',
    profileUpdated: '资料已更新',
  },
  myPosts: {
    title: '发布记录',
    allRecords: '全部记录',
    images: '图片',
    videos: '视频',
    noContent: '尚未发布任何内容',
    deleteFailed: '删除失败',
    deleted: '已删除',
    publishNew: '发布新灵感',
    postsCount: '{{count}}篇',
    deleteConfirmTitle: '确认删除',
    deleteConfirmDesc: '删除后无法恢复，确定要删除吗？',
  },
  likesBookmarks: {
    title: '赞与收藏',
    liked: '赞过的',
    bookmarked: '收藏的',
    noLikes: '还没有赞过的内容',
    noBookmarks: '还没有收藏的内容',
  },
  browseHistory: {
    title: '浏览记录',
    noHistory: '暂无浏览记录',
    clearFailed: '清除失败',
    cleared: '浏览记录已清除',
    deletedPost: '已删除的帖子',
    clearConfirmTitle: '清除浏览记录',
    clearConfirmDesc: '清除后无法恢复，确定要清除所有浏览记录吗？',
  },
  social: {
    followers: '粉丝',
    following: '关注',
    noFollowers: '还没有粉丝',
    noFollowing: '还没有关注的人',
    followBack: '回关',
    follow: '关注',
    followed: '已关注',
    followSuccess: '关注成功',
    unfollowSuccess: '已取消关注',
  },
  search: {
    placeholder: '搜索内容...',
    history: '搜索历史',
    trending: '热门榜',
    noResults: '未找到相关内容',
    tryOther: '换个关键词试试吧',
    searching: '搜索中...',
    views: '浏览',
    noTrending: '暂无热榜数据',
    matchTitle: '标题',
    matchContent: '内容',
    matchCategory: '分类',
    matchTag: '话题',
  },
  login: {
    savedAccounts: '快速登录',
    continueGoogle: '使用 Google 登录',
    continueGoogleLoading: '正在连接 Google...',
    continueApple: '使用 Apple 登录',
    continueAppleLoading: '正在连接 Apple...',
    emailAddress: '邮箱登录',
    phoneNumber: '手机号登录',
    terms: '进入即表示您同意我们的',
    termsOfService: '服务条款',
    privacyPolicy: '隐私政策',
    quickAccess: '快速登录',
    demoAccount: '体验账号',
    quickAccessTitle: '快速登录',
    quickAccessDesc: '使用体验账号快速探索应用',
    guestAccess: '访客登录',
    guestAccessDesc: '创建体验账号并立即登录',
    testEnv: '测试环境登录',
    testEnvDesc: '选择测试账号身份进入应用',
    newUser: '新用户',
    newUserDesc: '全新账号，体验完整注册流程',
    existingUser: '老用户',
    existingUserDesc: '已有档案数据的测试账号',
    loginFirstExisting: '请先用新用户登录一次',
    testLogging: '正在登录测试账号...',
    testLoginFailed: '测试登录失败',
    googleNotEnabled: 'Google 登录暂未启用，请使用邮箱登录',
    googleLoginFailed: 'Google 登录失败',
    googleTimeout: 'Google 登录超时，请重试',
    appleNotEnabled: 'Apple 登录暂未启用',
    appleLoginFailed: 'Apple 登录地址生成失败',
    appleTimeout: 'Apple 登录超时，请重试',
    loginSuccess: '登录成功',
    signingIn: '正在登录...',
    signInFailed: '登录失败',
    signInSuccess: '登录成功',
    invalidRedirect: '无效的登录重定向地址',
    or: '或',
    cancel: '取消',
  },
  createPost: {
    publishImage: '发布图文',
    publishVideo: '发布视频',
    publish: '发布',
    publishing: '发布中...',
    titleLabel: '标题',
    titlePlaceholder: '为这段灵感起个名字...',
    descLabel: '描述',
    descPlaceholderImage: '记录这一刻的星象感悟或能量流转...',
    descPlaceholderVideo: '描述你的视频内容...',
    selectCategory: '选择分类',
    categoryRequired: '*必选',
    tagNebula: '话题星云',
    exploreMore: '探索更多',
    collapse: '收起',
    addImage: '添加图片',
    clickSelectVideo: '点击选择视频',
    videoSpec: '支持 MP4、MOV，最大 200MB',
    coverOptional: '封面图（可选）',
    addCover: '添加封面',
    videoTooLarge: '视频文件不能超过 200MB',
    videoSelectFailed: '视频选取失败，请重试',
    selectCategoryPrompt: '请选择一个分类',
    enterTitle: '请填写标题',
    addAtLeastOneImage: '请至少添加一张图片',
    addVideo: '请添加视频',
    enterDesc: '请填写描述',
    selectAtLeastOneTag: '请至少选择一个话题',
    maxTags: '最多选择 {{count}} 个标签',
    customTagPlaceholder: '输入自定义话题...',
    addTag: '添加',
    searchTagPlaceholder: '搜索话题...',
    noMatchTag: '无匹配话题，试试自定义添加',
    noCommunityTag: '暂无社区话题',
    selectedCount: '已选 {{selected}}/{{max}} 个标签',
    footer: '专注创作 · 灵感永恒',
    preparing: '准备发布...',
    generatingCover: '生成封面中...',
    uploadingVideo: '上传视频中...',
    uploadingCover: '上传封面 {{current}}/{{total}}...',
    uploadingImage: '上传图片 {{current}}/{{total}}...',
    posting: '正在发布...',
    publishSuccess: '发布成功 ✨',
    publishFailed: '发布失败',
  },
  dailyFortune: {
    title: '每日心情',
    refreshed: '运势已更新 ✨',
    refreshFailed: '更新失败，请稍后再试',
    aiSuggestion: '行程顾问建议',
    love: '爱情',
    wealth: '财富',
    career: '事业',
    study: '学习',
    social: '人际',
    luckyColor: '幸运色',
    luckyAccessory: '开运饰品',
    luckyHour: '吉时',
    luckyDirection: '方位',
    luckyNumbers: '数字',
    luckyFood: '开运饮食',
    luckyFlower: '吉花',
    wuxing: '五行',
    defaultTip: '感受当下的能量',
    energyScore: '能量指数',
    luckMatrix: '幸运矩阵',
  },
  astroProfile: {
    title: '个人档案',
    myProfile: '我的档案',
    associatedProfiles: '关联档案',
    noProfiles: '尚未创建任何档案',
    noProfilesDesc: '创建你的第一个档案，开始探索个性化分析',
    addNew: '添加新档案',
    self: '本人',
    notSet: '未设置',
    notSetNickname: '未设置昵称',
    male: '♂ 男',
    female: '♀ 女',
    identitySelf: '自己',
    identityBoyfriend: '男友',
    identityGirlfriend: '女友',
    identitySpouse: '配偶',
    identityFriend: '朋友',
    identityParent: '父母',
    identityChild: '子女',
    identitySibling: '兄弟姐妹',
    identityColleague: '同事',
    identityOther: '其他',
  },
  astroDialog: {
    title: '个人档案设置',
    subtitle: '基础信息',
    nickname: '昵称',
    nicknamePlaceholder: '请输入您的昵称',
    relationship: '情感状态',
    gender: '性别',
    genderRequired: '出生时性别',
    genderMale: '男',
    genderFemale: '女',
    single: '单身',
    coupled: '恋爱中',
    married: '已婚',
    divine: '灵魂伴侣',
    nonBinary: '非二元',
    female: '女性',
    male: '男性',
    birthDatetime: '出生时间',
    birthPlace: '出生地',
    birthPlacePlaceholder: '请输入城市名称',
    currentCity: '现居地',
    currentCityPlaceholder: '请输入城市名称',
    timezoneCalibration: '时区校准',
    birthTimezone: '出生时区',
    tzChina: 'GMT +08:00 (中国标准时间)',
    tzGmt: 'GMT +00:00 (格林威治标准时间)',
    tzEst: 'GMT -05:00 (东部标准时间)',
    daylightSaving: '夏令时',
    dstOn: '夏令时校正已开启',
    dstOff: '夏令时校正已关闭',
    submit: '保存档案',
    submitting: '保存中...',
    saved: '档案已保存',
    footer: '完善您的个人信息，获取专属分析。',
    newProfile: '新建档案',
    editProfile: '编辑档案',
    createProfile: '创建档案',
    saveChanges: '保存修改',
    profileCreated: '档案已创建',
    profileUpdated: '档案已更新',
    profileDeleted: '档案已删除',
    deleteFailed: '删除失败',
    saveFailed: '保存失败',
    selectGender: '请选择出生时性别',
    enterNickname: '请输入昵称',
    selfExists: '已存在「自己」的档案，每人只能有一个',
    selfSyncNote: '选择「自己」将同步昵称到账户，每人仅限一个',
    identityRelation: '身份关系',
    selectIdentity: '请选择身份关系',
    selectIdentityTitle: '选择身份关系',
    alreadyExists: '(已存在)',
    solar: '阳历',
    lunar: '农历',
    selectBirthTime: '请选择出生时间',
    selectSolarTime: '选择阳历出生时间',
    selectLunarTime: '选择农历出生时间',
    lunarAutoConvert: '农历日期将自动转换为阳历存储',
    yearUnit: '年',
    monthUnit: '月',
    dayUnit: '日',
    hourUnit: '时',
    minuteUnit: '分',
    confirmBtn: '确定',
    selectTimezone: '选择出生时区',
    selectLocation: '请选择',
    searchLocation: '搜索地区...',
    allRegions: '全部',
    goBack: '返回上级',
    selectThis: '选择「{{name}}」',
    noLocationMatch: '未找到匹配地区',
    syncBirthPlace: '同步出生地',
    newFooter: '创建新的个人档案，获取个性化分析。',
    editFooter: '更新您的个人信息。',
    identityPet: '宠物',

    // Timezone labels
    tzJpKr: 'GMT +9 日韩',
    tzIndia: 'GMT +5:30 印度',
    tzSea: 'GMT +7 东南亚',
    tzMoscow: 'GMT +3 莫斯科',
    tzEastEu: 'GMT +2 东欧',
    tzCentralEu: 'GMT +1 中欧',
    tzGreenwich: 'GMT +0 格林威治',
    tzUsEast: 'GMT -5 美东',
    tzUsCentral: 'GMT -6 美中',
    tzUsMountain: 'GMT -7 美山地',
    tzUsWest: 'GMT -8 美西',
    tzAuEast: 'GMT +10 澳东',
    tzNz: 'GMT +12 新西兰',
    tzChinaLabel: 'GMT +8 中国',

    // Lunar month names
    lunarMonth1: '正', lunarMonth2: '二', lunarMonth3: '三',
    lunarMonth4: '四', lunarMonth5: '五', lunarMonth6: '六',
    lunarMonth7: '七', lunarMonth8: '八', lunarMonth9: '九',
    lunarMonth10: '十', lunarMonth11: '冬', lunarMonth12: '腊',
  },
  onboarding: {
    title: '选择你感兴趣的',
    titleHighlight: '内容方向',
    subtitle: '至少选择 3 个类别，我们将为你个性化推荐',
    selectedCount: '已选 {{count}}/3',
    continue: '继续',
    preferenceSaved: '偏好设置完成 ✨',
    saveFailed: '设置失败',
  },
  invitation: {
    title: '邀请好友',
    rules: '规则',
    myInviteCode: '我的邀请码',
    codeCopied: '邀请码已复制',
    linkCopied: '邀请链接已复制',
    shareText: '来MyCue一起探索吧！使用我的邀请码 {{code}} 注册即可',
    earnedPoints: '已获得 {{points}}/{{max}} 积分',
    shareLink: '分享链接',
    sharePoster: '分享海报',
    records: '邀请记录',
    noRecords: '还没有邀请记录',
    maxReached: '已达上限',
    rulesTitle: '邀请规则',
    rule1: '每位用户拥有专属邀请码，可通过链接、邀请码或海报分享给好友',
    rule2: '新用户注册时填写邀请码，邀请人即可获得 10 积分奖励',
    rule3: '每位用户最多通过邀请获得 100 积分（邀请 10 人）',
    rule4: '邀请码仅限新用户注册时使用，每人只能填写一次',
    posterSubtitle: '探索属于你的精彩世界',
    posterBottom: '扫码或使用邀请码注册',
    posterSaved: '海报已保存',
    scanToJoin: '扫码加入 MyCue',
    savePoster: '保存海报',
    inviteCodeLabel: '邀请码（选填）',
    inviteCodePlaceholder: '输入邀请码',
    inviteSuccess: '邀请码绑定成功',
    inviteAlreadyUsed: '你已经使用过邀请码了',
    inviteInvalid: '无效的邀请码',
    inviteSelf: '不能使用自己的邀请码',
  },
  userProfile: {
    noPosts: '该用户还没有发布内容',
  },
  notFound: {
    title: '404',
    subtitle: 'Page Not Found',
    desc: '您访问的页面不存在。',
    returnHome: 'Return Home',
  },
  levelInfo: {
    title: '修仙等级',
    current: '当前',
    startingLevel: '注册即可获得',
    pointsRequired: '累计 {{points}} 积分升级',
    howToEarn: '发帖每次 +10 积分，邀请好友每次 +10 积分，积分可消耗使用 AI 服务。',
    howToEarnXp: '使用 AI 服务消耗积分时，每消耗 1 积分即获得 1 点经验值；发帖审核通过后可获得 10 经验值。经验值累计达到门槛自动升级。',
    maxLevel: '🎉 已达到最高等级！',
    currentPoints: '当前 {{points}} 积分',
    currentXp: '当前 {{xp}}',
    pointsRemaining: '还差 {{points}} 积分升级',
    xpRemaining: '还差 {{xp}} XP 升级',
  },
  points: {
    title: '我的积分',
    currentBalance: '当前积分余额',
    balanceDesc: '积分可用于 AI 智能服务',
    recharge: '充值积分',
    earnRules: '获取方式',
    rulePost: '发布帖子',
    rulePostDesc: '每发布一篇帖子可获得 10 积分',
    rulePostLimit: '每日发帖积分上限 30 分',
    ruleInvite: '邀请好友',
    ruleInviteDesc: '每成功邀请一位好友可获得 10 积分',
    ruleInviteLimit: '最多通过邀请获得 100 积分（10 人）',
    history: '积分记录',
    noHistory: '暂无积分记录',
    rechargeTitle: '积分充值',
    rechargeDesc: '充值功能即将上线，敬请期待',
    selectPlan: '选择充值方案',
    pointsUnit: '积分',
    bestValue: '最划算',
    popular: '热门',
    superValue: '超值',
    buyNow: '立即购买',
    purchasing: '购买中...',
    purchaseSuccess: '充值成功！已到账 {{points}} 积分',
    purchaseFailed: '购买失败，请稍后重试',
    purchaseFailedDesc: '如持续出现问题，请重启应用或联系客服',
    productNotAvailable: '商品暂不可用',
    productNotAvailableDesc: '该商品尚未上架，请稍后再试',
    networkError: '网络连接失败',
    networkErrorDesc: '请检查网络连接后重试',
    paymentNotAllowed: '支付受限',
    paymentNotAllowedDesc: '当前设备或账户不支持支付，请检查支付设置',
    webPrice: '网页价',
    iosPrice: 'iOS 价',
    perPoint: '约 {{price}} / 积分',
    paymentPending: '支付系统即将上线',
    paymentPendingDesc: '支付接口正在对接中，请稍后再来',
    billingNotReady: '支付服务加载中',
    billingNotReadyDesc: '请稍后重试，如持续出现请重启应用',
    nativeOnly: '请在 App 中购买',
    nativeOnlyDesc: '积分充值仅支持在 iOS / Android App 内购买',
    alreadyProcessed: '该交易已处理过',
  },
  comment: {
    comments: '评论',
    noComments: '暂无评论，快来抢沙发 ✨',
    viewAll: '查看全部 {{count}} 条评论',
    hot: '最热',
    new: '最新',
    replyTo: '回复',
    replyPlaceholder: '回复 @{{name}}...',
    inputPlaceholder: '发表你的看法...',
    sayPlaceholder: '说点什么...',
  },
  postDetail: {
    publishedAt: '发布于',
    reads: '阅读',
    notFoundTitle: '内容已消散在星尘中',
    notFoundDesc: '这条灵感可能已被删除或从未存在过',
    backToExplore: '返回探索',
    bookmark: '收藏',
    commentPlaceholder: '发表你的看法...',
    imageTooLarge: '图片不能超过5MB',
    imageUploadFailed: '图片上传失败',
    imageLabel: '[图片]',
  },
  phone: {
    title: '手机号验证',
    desc: '我们将发送短信验证码到您的手机，以确认您的身份。',
    placeholder: '请输入手机号',
    sendCode: '获取验证码',
    resend: '重新发送',
    resendCountdown: '重新发送 ({{count}}s)',
    enterOtp: '请输入6位验证码',
    verifying: '验证中...',
    confirmLogin: '确认登录',
    otpSent: '验证码已发送',
    loginSuccess: '登录成功！',
    phoneDisabled: '手机登录暂未开启，请使用邮箱或 Google 登录',
    enterPhone: '请输入手机号',
    selectCountry: '选择国家/地区',
    searchCountry: '搜索国家或区号...',
    noResults: '未找到结果',
  },
  categoryFilter: {
    title: '筛选推荐偏好',
    subtitle: '选择 3 个你感兴趣的方向',
    confirmPreferences: '确认偏好',
  },
  timeAgo: {
    minutesAgo: '{{count}}分钟前',
    hoursAgo: '{{count}}小时前',
    daysAgo: '{{count}}天前',
  },
  messages: {
    title: '消息中心',
    likes: '被赞',
    comments: '被评论',
    system: '系统通知',
    noNotifications: '暂无消息',
    justNow: '刚刚',
    today: '今天',
    yesterday: '昨天',
    likedYourPost: '赞了你的帖子',
    commentedOnPost: '评论了你的帖子',
    repliedToComment: '回复了你的评论',
    earnedPostPoints: '你的帖子发布成功，获得积分',
    earnedInvitePoints: '邀请好友成功，获得积分',
    systemNotification: '系统通知',
    pts: '积分',
    markAllRead: '全部已读',
    allMarkedRead: '已全部标记为已读',
    noUnread: '没有未读消息',
    deleteFailed: '删除失败',
    emptyLikes: '还没有人给你点赞哦',
    emptyComments: '还没有收到评论',
    emptySystem: '暂无系统消息',
  },
  feedback: {
    title: '问题反馈',
    categoryBug: '🐛 Bug',
    categorySuggestion: '💡 建议',
    categoryUi: '🎨 界面',
    categoryOther: '💬 其他',
    placeholder: '请描述你遇到的问题或建议...',
    addScreenshot: '添加截图',
    maxScreenshots: '最多添加{{count}}张截图',
    screenshotFailed: '截图上传失败',
    submit: '提交反馈',
    submitFailed: '提交失败，请重试',
    thankYou: '感谢你的反馈！',
  },
  forceUpdate: {
    title: '发现新版本 🚀',
    currentVersion: '当前版本',
    noLongerSupported: '已不再支持',
    pleaseUpdate: '请更新到',
    toContinue: '后继续使用',
    updateNow: '立即更新',
  },
  conversation: {
    title: '对话记录',
    newChat: '新对话',
    noRecords: '暂无对话记录',
    justNow: '刚刚',
    minutesAgo: '{{count}} 分钟前',
    hoursAgo: '{{count}} 小时前',
    daysAgo: '{{count}} 天前',
  },
  dataSource: {
    label: '结合数据源（可多选）',
    selectSource: '选择数据源',
    allData: '已结合全部数据',
    combinedWith: '已结合{{sources}}数据',
    noSelect: '不选择',
    selectAll: '全选',
    collapse: '收起',
    bazi: '八字',
    astrology: '星座',
    ziwei: '紫微',
  },
  aiCommon: {
    generating: '正在生成分享图...',
    imageSaved: '图片已保存',
    shareGenerated: '分享图已生成',
    generateFailed: '生成失败，请重试',
    shareFailed: '分享失败，请重试',
    networkError: '网络错误，请重试',
    tooFrequent: '请求过于频繁，请稍后再试',
    insufficientPoints: '积分不足，请先获取更多积分',
    aiQuotaExhausted: 'AI 额度不足',
    aiFailed: 'AI 解读失败',
    cannotReadStream: '无法读取流',
    perUse: '/次',
    chartGenerated: '✨ 星盘数据已生成并缓存',
    energyRefreshed: '✨ 能量峰值已重新生成',
    chartFailed: '生成星盘失败，请重试',
    askAi: '问问 AI',
    self: '本人',
  },
  tarot: {
    aiReading: 'AI 正在解读你的牌阵…',
    saveImage: '保存图片',
    generatingImage: '生成中…',
    imageSaved: '图片已保存',
    imageFailed: '生成图片失败，请重试',
    copied: '已复制解读内容',
    copyFailed: '复制失败',
    resetReading: '重新占卜',
  },
  insufficientPoints: {
    title: '积分不足',
    desc: '本次服务需要 {{required}} 积分，当前余额仅 {{current}} 积分。',
    hint: '发帖或邀请好友即可获得更多积分！',
    goEarn: '去赚取积分',
    inviteFriends: '邀请好友得积分',
  },
  video: {
    share: '分享',
    linkCopied: '链接已复制',
  },
  aiTarot: {
    pageTitle: '灵感卡牌',
    pageSubtitle: 'CUECARDS INSIGHT',
    loaderText: '灵感能量汇聚中…',
    stepSpread: '选择牌阵',
    stepQuestion: '冥想提问',
    stepDraw: '抽取牌面',
    stepReading: '解读启示',
  },
  aiBazi: {
    pageTitle: '生辰解析',
    noProfileMsg: '请先创建星盘档案并填写出生时间',
    missingBirthTime: '所选档案缺少出生时间信息',
    createProfile: '创建档案',
    completeProfile: '完善档案',
    selfLabel: '本人',
    addProfile: '添加新档案',
    tabNatal: '生辰',
    tabFlow: '流盘',
    aiReading: 'AI 解读',
    mainStar: '主星',
    dayMaster: '命主',
    yearPillar: '年柱',
    monthPillar: '月柱',
    dayPillarMale: '男命',
    dayPillarFemale: '女命',
    hourPillar: '时柱',
    tianGan: '天干',
    diZhi: '地支',
    hideGan: '藏干',
    diShi: '地势',
    ziZuo: '自坐',
    daYun: '大运',
    liuNian: '流年',
    liuYue: '流月',
    naYin: '纳音',
    kongWang: '空亡',
    diShiSection: '地势',
    diShiNote: '（长生十二宫）',
    shenSha: '神煞',
    tianGanRel: '天干关系',
    diZhiRel: '地支关系',
    noTianGanRel: '天干无合冲',
    noDiZhiRel: '地支无合冲刑破害',
    ageUnit: '岁',
    startYun: '起运',
    yuanJu: '原局',
  },
  aiZiwei: {
    pageTitle: '紫微解析',
    noProfileMsg: '请先创建星盘档案并填写出生时间',
    missingBirthTime: '所选档案缺少出生时间信息',
    createProfile: '创建档案',
    completeProfile: '完善档案',
    selfLabel: '本人',
    addProfile: '添加新档案',
    aiReading: 'AI 解读',
    // Chart labels
    levelDecadal: '大限',
    levelYearly: '流年',
    levelMonthly: '流月',
    levelDaily: '流日',
    levelHourly: '流时',
    levelLabelDecadal: '限',
    levelLabelYearly: '年',
    levelLabelMonthly: '月',
    levelLabelDaily: '日',
    levelLabelHourly: '时',
    bodyLabel: '身',
    selfPalace: '本宫',
    oppositePalace: '对宫',
    trianglePalace: '三合',
    clearOverlay: '清除',
    ageUnit: '岁',
    currentLabel: '当前',
    noDecadalData: '暂无大限数据',
    monthUnit: '月',
    // Horoscope summary
    decadalLimit: '大限',
    yearlyFlow: '流年',
    monthlyFlow: '流月',
    dailyFlow: '流日',
    hourlyFlow: '流时',
    decadalSiHua: '限四化',
    yearlySiHua: '年四化',
    // Palace detail
    bodyPalace: '身宫',
    originPalace: '来因宫',
    decadalRange: '大限 {{stem}}{{branch}} · {{start}}~{{end}}岁',
    siHuaTitle: '四化',
    majorStarsTitle: '主星',
    minorStarsTitle: '辅星',
    adjStarsTitle: '杂耀',
    sanFangTitle: '三方四正',
    patternEnergy: '格局能量',
    luDesc: '财禄',
    quanDesc: '权力',
    keDesc: '名声',
    jiDesc: '阻碍',
    siHuaDistribution: '四化分布',
    decadalFlowStars: '大限流耀',
    yearlyFlowStars: '流年流耀',
    twelveDeitiesTitle: '十二神煞',
    changsheng12: '长生12神',
    boshi12: '博士12神',
    jiangqian12: '将前12神',
    suiqian12: '岁前12神',
    minorAgesTitle: '小限年龄',
    // Star types
    starTypeMajor: '主星',
    starTypeSoft: '吉星',
    starTypeTough: '煞星',
    starTypeTianma: '天马',
    starTypeLucun: '禄存',
    starTypeFlower: '桃花星',
    starTypeHelper: '辅星',
    starTypeAdj: '杂耀',
    starDescMajor: '决定宫位核心能量',
    starDescSoft: '带来正面助力',
    starDescTough: '带来挑战与磨练',
    starDescTianma: '主迁动变化',
    starDescLucun: '主财禄稳固',
    starDescFlower: '主人缘与感情',
    starDescHelper: '辅助能量',
    starDescAdj: '微调宫位特质',
    // Brightness
    brightMiao: '庙',
    brightWang: '旺',
    brightDe: '得',
    brightLi: '利',
    brightPing: '平',
    brightBu: '不',
    brightXian: '陷',
    brightDescMiao: '星耀最强，发挥极佳',
    brightDescWang: '星耀强旺，能量充沛',
    brightDescDe: '星耀得地，正常发挥',
    brightDescLi: '星耀有利，略有助益',
    brightDescPing: '星耀平常，不好不坏',
    brightDescBu: '星耀失地，发挥受限',
    brightDescXian: '星耀陷落，负面较多',
    // Mutagen labels
    mutagenLu: '化禄 · 财运亨通',
    mutagenQuan: '化权 · 掌权有力',
    mutagenKe: '化科 · 声名远扬',
    mutagenJi: '化忌 · 阻碍波折',
    // Relation config
    relationTriangle: '三合',
    relationOpposite: '对宫',
    relationTriangleDesc: '助力与资源',
    relationOppositeDesc: '互补与对冲',
    // Star meanings
    starZiwei: '帝王之星，领导力强，尊贵高傲，喜掌权',
    starTianji: '智慧之星，善谋略，好学多思，变动不定',
    starTaiyang: '光明之星，主贵，热情慷慨，利于公职',
    starWuqu: '财星，刚毅果断，善理财，性格刚强',
    starTiantong: '福星，温和善良，知足常乐，缺乏魄力',
    starLianzhen: '次桃花星，聪明机敏，好胜心强，多才多艺',
    starTianfu: '财库之星，稳重大方，守成有余，保守务实',
    starTaiyin: '财星，温柔细腻，善于理财，重感情',
    starTanlang: '桃花主星，多才多艺，欲望强烈，善交际',
    starJumen: '暗星，口才好，是非多，善于分析',
    starTianxiang: '印星，温文尔雅，乐于助人，依附性强',
    starTianliang: '荫星，正直善良，逢凶化吉，操心劳碌',
    starQisha: '将星，刚强果敢，开创力强，孤独奋斗',
    starPojun: '耗星，冲劲十足，破旧立新，变动剧烈',
    starZuofu: '贵人星，善于辅佐，人缘好，助力多',
    starYoubi: '贵人星，善于协助，贵人缘佳，暗中助力',
    starWenchang: '科甲星，聪明好学，文才出众，利考试',
    starWenqu: '才艺星，多才多艺，感性浪漫，桃花重',
    starTiankui: '阳贵人，白天贵人相助，利于男性贵人',
    starTianyue: '阴贵人，夜间贵人相助，利于女性贵人',
    starQingyang: '刑星，性格刚烈，冲劲足，易有伤灾',
    starTuoluo: '暗耗星，拖延纠缠，做事反复，暗中损耗',
    starHuoxing: '暴星，性急冲动，爆发力强，成败迅速',
    starLingxing: '暗火星，闷骚急躁，暗中发力，突发变化',
    starDikong: '空亡星，超脱世俗，宜宗教艺术，不利财',
    starDijie: '劫财星，突发变故，破耗不定，宜技术',
    starLucunStar: '正财星，稳定财源，节俭保守，有进无退',
    starTianmaStar: '驿马星，主迁动奔波，适合外出发展',
    starHongluan: '正桃花，婚恋喜庆，感情顺利',
    starTianxi: '喜庆星，婚姻喜事，人缘佳',
    starXianchi: '桃花星，异性缘重，风流多情',
    starTianyao: '桃花星，魅力出众，异性缘佳，暗桃花',
    starTianxing: '刑罚星，宜法律军警，性格严厉',
    starTianku: '悲伤星，多愁善感，宜艺术创作',
    starTianxu: '虚耗星，表面风光，内心空虚',
    starLongchi: '才艺星，艺术天赋，品味高雅',
    starFengge: '文艺星，风雅不俗，有审美眼光',
    starTiancai: '聪慧星，天资聪颖，理解力强',
    starTianshou: '长寿星，身体康健，性格开朗',
    starTianguan: '官禄星，利仕途，有官运',
    starTianfu2: '福德星，有福气，生活安逸',
    starTianchu: '食禄星，口福好，利餐饮业',
    starEnguang: '贵人星，受长辈恩惠，有提拔运',
    starTiangui: '贵气星，气质高贵，社会地位佳',
    starSantai: '辅佐星，有助力，循序渐进',
    starBazuo: '权贵星，有威仪，受人尊敬',
    starTaifu: '辅佐星，有靠山，贵人暗助',
    starFenggao: '封赏星，有荣誉，功名可期',
    starJieshen: '化解星，逢凶化吉，消灾解厄',
    starTianwu: '玄学星，有灵感，宜玄学宗教',
    starHuagai: '孤高星，才华出众，清高孤傲，宜宗教',
    starGuchen: '孤独星，性格孤僻，独立自主',
    starGuasu: '孤寡星，感情不顺，宜晚婚',
    starFeilian: '是非星，口舌是非，小人暗害',
    starPosui: '破损星，事多波折，不够完美',
    starTiankong2: '空想星，想象丰富，不切实际',
    starJiekong: '截断星，中断阻碍，虎头蛇尾',
    starXunkong: '空亡星，空虚不实，有名无实',
    starTianshang: '伤害星，易受伤，注意安全',
    starTianshi: '使者星，服务他人，有奉献精神',
    starYinsha: '暗害星，小人暗算，防暗箭',
    starTianyue2: '疾病星，体质偏弱，注意健康',
    starYuede: '德星，心地善良，逢灾有救',
    starTiande: '大德星，品行端正，遇难呈祥',
    // Center panel
    yang: '阳',
    yin: '阴',
    male: '男',
    female: '女',
    hour_zi: '子时',
    hour_chou: '丑时',
    hour_yin: '寅时',
    hour_mao: '卯时',
    hour_chen: '辰时',
    hour_si: '巳时',
    hour_wu: '午时',
    hour_wei: '未时',
    hour_shen: '申时',
    hour_you: '酉时',
    hour_xu: '戌时',
    hour_hai: '亥时',
  },
  aiAstrology: {
    pageTitle: '星象罗盘',
    selectProfile: '选择档案',
    selfLabel: '本人',
    addProfile: '添加新档案',
    readingChart: '正在解读星盘...',
    selectToView: '选择档案以查看星盘解读',
    energyPeaks: '能量峰值',
    energyPeaksEn: 'ENERGY PEAKS',
    recalculate: '重算',
    love: '爱情',
    career: '事业',
    wealth: '财富',
    social: '人际',
    luck: '运气',
    wisdom: '智慧',
    emotion: '情绪',
    intellect: '智识',
    health: '健康',
    creativity: '创意',
    inputPlaceholder: '今年财富上有什么建议？',
  },
  aiTravel: {
    pageTitle: '行程顾问',
    selectProfile: '选择档案',
    selfLabel: '本人',
    addProfile: '添加新档案',
    greeting: '"时空能量正在流动，寻求指引的旅者。"',
    energyTitle: '当前出行能量对齐',
    alignment: 'Alignment',
    energyDesc: '磁场能量显示，今日{{direction}}方位具有显著的能量提升空间，最佳出行时段为{{hour}}。',
    loadingEnergy: '今日能量数据加载中…',
    loadingHint: '请先在首页生成今日运势',
    luckyDir: '🧭 吉方：{{value}}',
    luckyHour: '🕐 吉时：{{value}}',
    luckyColor: '🎨 幸运色：{{value}}',
    luckyItem: '💎 幸运物：{{value}}',
    guidedTitle: '深度指引对话',
    q1: '我的幸运方位该如何布局出行？',
    q2: '如果要避开今日不利，我该走哪条路？',
    q3: '今日适合远行还是居家静修？',
    q4: '在什么时间段出门能提升财运？',
    q5: '出行时携带什么幸运物最能加持能量？',
    inputPlaceholder: '输入你的出行疑问...',
    streaming: '正在感应时空能量…',
  },
  aiQuery: {
    pageTitle: '量子问答',
    selectProfile: '选择档案',
    selfLabel: '本人',
    addProfile: '添加新档案',
    greeting: '你好，我是星界引路人。凡事皆有定数，亦有变数。请问今日你想探寻哪方面的天机？',
    q1: '我近期的财运如何？',
    q2: '目前的感情现状有何建议？',
    q3: '事业上是否面临转机？',
    q4: '今日灵感指数是多少？',
    inputPlaceholder: '向天请教...',
    streaming: '正在感应天机…',
  },
  tarotSpread: {
    chooseSpread: '选择你的牌阵',
    title: '选择牌阵',
    cardsUnit: '牌',
    bottomHint: '点击牌阵开始你的占卜之旅',
  },
  tarotQuestion: {
    customLabel: '自由提问',
    customDesc: '问你心中所想',
    dailyLabel: '日运',
    dailyDesc: '今日能量指引',
    monthlyLabel: '月运',
    monthlyDesc: '本月运势走向',
    yearlyLabel: '年运',
    yearlyDesc: '年度全局展望',
    customQ1: '我的感情近期会有什么变化？',
    customQ2: '事业上我应该坚持还是转型？',
    customQ3: '最近的财运如何？',
    customQ4: '我该如何改善人际关系？',
    dailyQ1: '今天我需要注意什么？',
    dailyQ2: '今天的感情运势如何？',
    dailyQ3: '今天适合做重要决定吗？',
    dailyQ4: '今天的贵人方位在哪？',
    monthlyQ1: '这个月的事业发展如何？',
    monthlyQ2: '本月感情会有转机吗？',
    monthlyQ3: '这个月的财务状况怎样？',
    monthlyQ4: '本月我应该把重心放在哪？',
    yearlyQ1: '今年整体运势走向如何？',
    yearlyQ2: '今年事业会有突破吗？',
    yearlyQ3: '今年感情上会有大变化吗？',
    yearlyQ4: '今年最需要注意的事情是什么？',
    defaultCustom: '请为我指引方向',
    defaultDaily: '请为我解读今日运势',
    defaultMonthly: '请为我解读本月运势',
    defaultYearly: '请为我解读今年运势',
    inputHint: '请输入或选择一个问题',
    quickSelect: '快速选择',
    back: '返回',
    startDraw: '开始抽牌',
    customPlaceholder: '静心冥想...写下你的问题',
    fortunePlaceholder: '关于{{mode}}，你想问什么？',
  },
  tarotReading: {
    yourQuestion: '你的提问',
    destinyTitle: '命运启示',
    aiReadingDesc: 'AI 智能分析为你深度解读',
    reversed: '逆位',
    retryHint: '请稍后重试或更换问题',
    notLoggedIn: '未登录',
    readingFailed: '解读失败',
    positionFallback: '位置{{index}}',
    shareTitle: '灵感卡牌解读',
    historyFallback: '灵感卡牌',
  },
  tarotDeck: {
    preloadText: '仪式准备中，请静心感应…',
    preloadSubtext: '灵感场域正在稳定',
    shuffling: '洗牌中',
    shuffleHint: '静心冥想，感受牌的能量引导',
    selectPrompt: '凭直觉选择第 {{current}} / {{total}} 张牌',
    gatherTitle: '牌阵已成',
    gatherHint: '命运之牌正在汇聚...',
    revealTitle: '命运揭示中...',
    cardsUnit: '张牌',
  },
  ziweiCenter: {
    beijingTime: '北京时间',
    lunarTime: '农历时间',
    solarPillars: '节气四柱',
    soulMaster: '命主',
    bodyMaster: '身主',
    soulPalace: '命宫',
    bodyPalace: '身宫',
    ziYearDou: '子年斗君',
    selfTransform: '本宫自化',
    oppositeIn: '对宫化入',
    siHuaColors: '四化颜色',
    lu: '禄',
    quan: '权',
    ke: '科',
    ji: '忌',
  },
  aiHistory: {
    title: '使用记录',
    all: '全部',
    noRecords: '暂无使用记录',
    retentionNote: '记录保存6个月',
    deleted: '已删除',
    spread: '牌阵',
    profile: '档案',
    viewHistory: '历史记录',
  },
  privacy: {
    title: '隐私政策',
    lastUpdated: '最后更新：2026年2月24日',
    s1Title: '1. 我们收集的信息',
    s1Intro: '我们收集以下类型的信息：',
    s1AccountLabel: '账户信息：',
    s1Account: '您创建账户时提供的电子邮件地址、手机号码、显示名称和头像。',
    s1OAuthLabel: 'OAuth 数据：',
    s1OAuth: '当您通过 Google 登录时，我们会接收您授权的姓名、电子邮件和头像。',
    s1ContentLabel: '用户内容：',
    s1Content: '您在应用中创建的帖子、评论、点赞和收藏。',
    s1UsageLabel: '使用数据：',
    s1Usage: '关于您如何使用应用的信息，包括访问的页面和使用的功能。',
    s1DeviceLabel: '设备信息：',
    s1Device: '设备类型、操作系统和浏览器类型。',
    s2Title: '2. 我们如何使用您的信息',
    s2a: '提供、维护和改进应用',
    s2b: '个性化您的体验，包括每日运势解读',
    s2c: '就更新和新功能与您沟通',
    s2d: '检测、预防和解决安全问题',
    s2e: '遵守法律义务',
    s3Title: '3. 数据存储与安全',
    s3Body: '您的数据安全地存储在 Supabase 基础设施上，支持静态和传输加密。我们采用行业标准的安全措施，包括行级安全（RLS）策略，确保用户只能访问自己的数据。我们不会将您的个人信息出售给第三方。',
    s4Title: '4. 数据共享',
    s4Intro: '我们不会出售、交易或出租您的个人信息。我们仅在以下情况下共享数据：',
    s4a: '经您同意',
    s4b: '遵守法律要求或回应合法请求',
    s4c: '保护我们的权利、隐私、安全或财产',
    s4d: '与合并、收购或资产出售相关',
    s5Title: '5. 您的权利',
    s5Intro: '您有权：',
    s5a: '访问您的个人数据',
    s5b: '更正不准确的数据',
    s5c: '删除您的账户及相关数据',
    s5d: '以可携带格式导出您的数据',
    s5e: '选择退出非必要通信',
    s6Title: '6. Cookie 与追踪',
    s6Body: '应用使用必要的 Cookie 和本地存储进行身份验证和会话管理。我们不使用第三方广告追踪 Cookie。',
    s7Title: '7. 儿童隐私',
    s7Body: '本应用不面向13岁以下的用户。我们不会故意收集13岁以下儿童的个人信息。如果我们发现13岁以下儿童向我们提供了个人信息，我们将立即删除。',
    s8Title: '8. 政策变更',
    s8Body: '我们可能会不时更新本隐私政策。我们将通过在应用内发布新政策来通知您任何重大变更。变更发布后您继续使用即表示接受修订后的政策。',
    s9Title: '9. 联系我们',
    s9Body: '如果您对本隐私政策有任何疑问或顾虑，请通过以下邮箱联系我们：',
  },
  terms: {
    title: '服务条款',
    lastUpdated: '最后更新：2026年2月24日',
    s1Title: '1. 条款接受',
    s1Body: '访问或使用 MyCue（"本应用"）即表示您同意受本服务条款的约束。如果您不同意这些条款，请勿使用本应用。',
    s2Title: '2. 服务描述',
    s2Body: 'MyCue 是一个社区驱动的平台，提供神秘学和玄学内容，包括但不限于每日运势解读、星座洞察和用户生成的帖子。所有内容仅供娱乐和参考之用，不应被视为专业建议。',
    s3Title: '3. 用户账户',
    s3Body: '您必须创建账户才能使用某些功能。您有责任维护账户凭据的保密性，并对您账户下发生的所有活动负责。注册时您必须提供准确完整的信息。',
    s4Title: '4. 用户内容',
    s4Body: '您保留在 MyCue 上发布的内容的所有权。发布内容即表示您授予 MyCue 非独占性、全球性、免版税许可，以在应用内使用、展示、复制和分发您的内容。您同意不发布非法、有害、威胁、辱骂、诽谤或其他不当的内容。',
    s5Title: '5. 禁止行为',
    s5a: '冒充任何个人或实体',
    s5b: '骚扰、欺凌或恐吓其他用户',
    s5c: '发布垃圾信息、未经请求的广告或恶意内容',
    s5d: '试图未经授权访问应用或其系统',
    s5e: '将应用用于任何非法目的',
    s6Title: '6. 知识产权',
    s6Body: '应用上显示的所有商标、标识和服务标记均为 MyCue 或其各自所有者的财产。未经事先书面许可，您不得使用其中任何内容。',
    s7Title: '7. 免责声明',
    s7Body: '本应用按"现状"和"可用"基础提供，不提供任何明示或暗示的保证。MyCue 不保证应用将不间断、无错误或无病毒或其他有害组件。',
    s8Title: '8. 责任限制',
    s8Body: '在法律允许的最大范围内，MyCue 不对因您使用本应用而产生的或与之相关的任何间接、偶然、特殊、后果性或惩罚性损害承担责任。',
    s9Title: '9. 条款修改',
    s9Body: 'MyCue 保留随时修改这些条款的权利。我们将通知用户重大变更。修改后您继续使用本应用即表示接受更新后的条款。',
    s10Title: '10. 联系方式',
    s10Body: '如果您对这些条款有任何疑问，请通过以下邮箱联系我们：',
  },
  moderation: {
    title: '更多操作',
    reportTitle: '举报内容',
    reportContent: '举报此内容',
    reportContentDesc: '如果此内容违反社区准则，请举报',
    blockUser: '屏蔽 {{name}}',
    blockUserDesc: '屏蔽后将不再看到该用户的内容',
    reportSuccess: '举报已提交，我们会在24小时内处理',
    reportFailed: '举报提交失败',
    blockSuccess: '已屏蔽 {{name}}',
    blockFailed: '屏蔽失败',
    submitReport: '提交举报',
    descriptionPlaceholder: '补充说明（可选）',
    reason_spam: '垃圾内容',
    reason_harassment: '骚扰/欺凌',
    reason_inappropriate: '不当内容',
    reason_violence: '暴力/危险',
    reason_fraud: '欺诈/虚假',
    reason_other: '其他',
  },
};

export default zh;
